import type { InternalAxiosRequestConfig } from 'axios';
import { cleanQueryParams } from '@/utils/cleanQueryParams';
import { getLocale } from '@/utils/locale';

export const onRequestFulfilled = async (config: InternalAxiosRequestConfig<any>) => {
  config.headers['accept-language'] = getLocale();
  config.headers['x-ui-language'] = getLocale();
  config.headers['x-browser-language'] = navigator.language || '';
  // Remove empty strings and undefined from query params
  config.params = cleanQueryParams(config.params);

  return config;
};
